import React from 'react';


export default class Dialog extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        in_progress: false,
        link: '',
      };
    }
    
    componentDidMount() {
        console.log('componentDidMount');
    }

    componentWillReceiveProps(nextProps, nextContext) {
      console.log('componentWillReceiveProps');
      const { id, url } = nextProps;
      if(id !== this.state.id) {
        this.setState({ in_progress: false});
      }
      if(url) {
        this.setState({ link: url});
      }
    }

    onClick = (e) => {
      e.preventDefault();
      e.target.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24" fill="currentColor" class="fa-spin">
          <path d="M304 48c0-26.5 21.5-48 48-48 88.4 0 160 71.6 160 160 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-35.3-28.7-64-64-64-26.5 0-48-21.5-48-48zM96 304c26.5 0 48 21.5 48 48 0 35.3 28.7 64 64 64 26.5 0 48 21.5 48 48s-21.5 48-48 48C119.6 512 48 440.4 48 352c0-26.5 21.5-48 48-48z"/>
          <style>
            .fa-spin {
              animation: fa-spin 2s infinite linear;
            }
            @keyframes fa-spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          </style>
        </svg>
        Generate PDF
      `;
      e.target.disabled = true;
      const target = e.target;
      const { id, onClick } = this.props;
      this.setState({ in_progress: true});
      onClick('url', () => {
        this.setState({ in_progress: false});
        target.disabled = false;
        target.innerHTML = 'Generate PDF';
      });
      setTimeout(() => {
        this.setState({ in_progress: false});
        target.disabled = false;
        target.innerHTML = 'Generate PDF';
      }, 9000);
    }

    render() {
      const { id } = this.props;
      const { in_progress, link } = this.state;
      const link_name = link ? link.split('/').pop() : '';
      console.log('inside Dialog id: ' + id);
        return(
            <div className="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">Edit</h5>
                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                          <i class="fas fa-times me-1"></i>
                        </button>
                    </div>
                    <div className="modal-body">
                        {this.props.children}
                    </div>

                    <div className="modal-footer" style={{display: 'flex', justifyContent:'space-between'}}>
                        <div>
                          <button disabled={ in_progress ? 'disabled': '' } onClick={(e) => this.onClick(e)} id='generate_pdf' type="button" className="btn btn-secondary mr-1">Generate PDF</button>
                          <a href={link} target='_blank'> {link_name} </a>
                        </div>
                        <div>
                          <button type="button" className="btn btn-secondary" data-dismiss="modal">Ok</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}